module.exports = __webpack_public_path__ + "media/ponsardetdumas.6954aac5.mp4";